import React from 'react';
import { Home, Edit2 } from 'lucide-react';
import { Label } from '../../ui/label';
import { Button } from '../../ui/button';

const CustomerInfo = ({ estimate, onEdit }) => {
  return (
    <div className="bg-white rounded-lg shadow p-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold text-gray-900 flex items-center">
          <Home className="w-5 h-5 mr-2 text-blue-600" />
          Customer Information
        </h2>
        {onEdit && (
          <Button
            variant="outline"
            size="sm"
            onClick={onEdit}
            data-testid="edit-customer-btn"
          >
            <Edit2 className="w-4 h-4 mr-1" />
            Edit
          </Button>
        )}
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label className="text-gray-600">First Name</Label>
          <p className="text-gray-900 font-medium">
            {estimate.customer_first_name || 'N/A'}
          </p>
        </div>
        <div>
          <Label className="text-gray-600">Last Name</Label>
          <p className="text-gray-900 font-medium">
            {estimate.customer_last_name || 'N/A'}
          </p>
        </div>
        <div className="col-span-2">
          <Label className="text-gray-600">Address</Label>
          <p className="text-gray-900 font-medium">{estimate.address || 'N/A'}</p>
        </div>
        {estimate.customer_email && (
          <div className="col-span-2">
            <Label className="text-gray-600">Email</Label>
            <p className="text-gray-900 font-medium">{estimate.customer_email}</p>
          </div>
        )}
        {estimate.customer_phone && (
          <div className="col-span-2">
            <Label className="text-gray-600">Phone</Label>
            <p className="text-gray-900 font-medium">{estimate.customer_phone}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomerInfo;
